import React, { useContext } from 'react'
import { calcAvarageRadiant, calcAvarageDire } from './features/calcavarage';
const DataContext = React.createContext();

export function DataProvider({data, children}) {
  const { adv_boost, stats, ywsAdvatnage } = data;
  //radiant hero data (name + adv)
	const herodata = calcAvarageRadiant(stats);
	//dire hero data (name + adv)
	const direHeroData = calcAvarageDire(stats);
	//avarage advantage
	const avgAdvantage = herodata.reduce(
		(prev, curr) => {
			const [heroName, advantage] = curr;
			if (advantage === null) {
				return prev;
			}
			prev.heroCount++;
			prev.adv = prev.adv + Number(advantage);
			return prev;
		},
		{ heroCount: 0, adv: 0 }
	);

	const rawAvgAdvantage = avgAdvantage.adv / avgAdvantage.heroCount;
	const newAdvantage = (ywsAdvatnage + adv_boost) / 2;

	const lane_outcomes = Object.fromEntries(Object.entries(data.lane_outcomes).map(item => {
		const [key, value] = item;

		if(value.probability === 0) {
			return [key, {probability: null}]
		}

		return item;
	}))

  const extendedData = {
    ...data,
    rawAvgAdvantage,
    newAdvantage,
    herodata,
    direHeroData,
	lane_outcomes,
	ywsAdvatnage
  }

  return (
    <DataContext.Provider value={extendedData}>
        {children}
    </DataContext.Provider>
  )
}

export const useData = () => useContext(DataContext);